export default "__VITE_ASSET__ITNcuYG0__"